import { TRANSLOCO_SCOPE } from '@ngneat/transloco';

export const LAYOUT_ERROR_PROVIDERS = [
  {
    provide: TRANSLOCO_SCOPE,
    useValue: { scope: 'layout-error' }
  }
];
